import React, { useEffect, useState } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { Box, Grid } from '@mui/material';
import { FormModal } from 'components/molecules/Modal';
import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Elabels } from 'pages/CaseManagementPage/CasesPage/helpers';
import { useCase } from '../../hooks';
import { ActionTypes } from 'state/actions/alert';
import { useAlert } from 'models/alertContext';
import { Alert } from 'components/atoms/Alert';
import { FormInput } from 'components/molecules/FormInput';

interface IFormValues {
  summary: string;
}
const initialFormValues: IFormValues = { summary: '' };

interface ICloseTaskForm {
  caseId: string;
  close: () => void;
  isOpen: boolean;
  updateData: () => void;
}

const CloseTaskForm = ({ caseId, close, isOpen, updateData }: ICloseTaskForm) => {
  const { t } = useTranslations();
  const { handleCloseTask } = useCase();
  const [isSubmitLoading, setSubmitLoading] = useState(false);
  const { clearAlert, modalAlert } = useAlert();

  const schema = yup.object({
    summary: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(255, t('general.field.validation.maxCharacters').replace('{0}', '255')),
  });
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm<IFormValues>({
    defaultValues: initialFormValues,
    resolver: yupResolver(schema) as unknown as Resolver<IFormValues>,
  });

  useEffect(() => {
    clearAlert(ActionTypes.CLEAR_MODAL_ALERT);
  }, [isOpen]);

  const onCloseTaskForm = async (data: any) => {
    if (isSubmitLoading) return false;
    setSubmitLoading(true);
    const res = await handleCloseTask(caseId, data.summary);
    if (res) {
      updateData();
    }
    reset(initialFormValues);
    close();
    clearAlert(ActionTypes.CLEAR_MODAL_ALERT);
    setSubmitLoading(false);
  };

  return (
    <form onSubmit={handleSubmit(onCloseTaskForm)}>
      <FormModal
        open={isOpen}
        onClickClose={() => {
          close();
          reset(initialFormValues);
        }}
        onClickApprove={handleSubmit(onCloseTaskForm)}
        title={t(Elabels.closeTask)}
        titleLeft
        text={t(Elabels.closeTaskText)}
        width="90%"
        maxWidth="430px"
      >
        <Grid container>
          <Grid size={{ xs: 12 }}>
            <FormInput
              name="summary"
              label={t(Elabels.summary)}
              control={control}
              setValue={setValue}
              errors={errors}
              multiline={true}
              minRows={5}
              showCounter
              charsLimit={255}
              required
            />
          </Grid>
        </Grid>
        {modalAlert && (
          <Grid size={{ xs: 12 }}>
            <Box>
              <Alert text={modalAlert.text} variant={modalAlert.variant} />
            </Box>
          </Grid>
        )}
      </FormModal>
    </form>
  );
};

export default CloseTaskForm;
